import { useState } from "react";
import { faqs } from "@/mocks/faqData";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? -1 : index));
  };

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="mx-auto max-w-shell">
          <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,360px)_1fr] gap-8 lg:gap-14">
            <div>
              <span className="text-sm text-accent-700 font-label">常见问题</span>
              <h2 className="mt-2 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
                关于收录与使用，你可能想问
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
                导航站最重要的就是"靠谱"。下面几个问题把收录标准和维护方式讲清楚，看完再决定要不要常来。
              </p>
              <a
                href="#submit"
                className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-secondary-300 text-secondary-900 text-sm hover:bg-secondary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-question-answer-line"></i>
                还有问题？去收录申请留言
              </a>
            </div>

            <div className="flex flex-col gap-3">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div
                    key={faq.q}
                    className="rounded-lg bg-background-50 border border-background-200 overflow-hidden"
                  >
                    <button
                      type="button"
                      onClick={() => toggle(index)}
                      className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                    >
                      <span className="font-heading text-base font-semibold text-foreground-950">
                        {faq.q}
                      </span>
                      <i
                        className={`shrink-0 text-xl text-foreground-500 transition-transform ${
                          isOpen ? "ri-subtract-line" : "ri-add-line"
                        }`}
                      ></i>
                    </button>
                    {isOpen && (
                      <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                        {faq.a}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}